import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const BlogFeaturedSingle = ({ singlePost }) => {
  return (
    <div className="antera-blog-post-preview-container col-lg-4 col-sm-6">
      <div className="blog-wrap mb-30 scroll-zoom text-center">
        <div className="blog-img" style={{ minHeight: "300px" }} >
          <Link to={process.env.PUBLIC_URL + "/blogs/" + singlePost.blogUrl}>
            <img
              style={{ maxHeight: "250px",width:"auto" }}
              src={process.env.PUBLIC_URL + singlePost.blogImage}
              alt=""
              className="antera-blog-post-preview-image"
            />
          </Link>
        </div>
        <div className="blog-content-wrap">
          <div className="antera-blog-preview-content-container blog-content text-center">
            <h3 className="antera-blog-post-preview-title-text">
              <Link to={process.env.PUBLIC_URL + "/blogs/" + singlePost.blogUrl}>
                {singlePost.blogTitle}
              </Link>
            </h3>
            <span className="antera-blog-post-preview-author-text">
              By{" "}
              {singlePost.blogAuthor}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

BlogFeaturedSingle.propTypes = {
  singlePost: PropTypes.object
};

export default BlogFeaturedSingle;
